import {Money} from '../PulsoidClient';

export const formatMoney = (money: Money) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: money.currency,
  }).format(Number(money.amount));
};
